import {urlUtils} from 'santa-core-utils'
export const name = 'UrlUtilsAspect'

export const functionLibrary = {
    origin: urlUtils.origin,
    joinURL: (baseUrl = '', urlParts = []) => urlUtils.joinURL(...[baseUrl].concat(urlParts))
}
